import {initPlayer} from "./video-player";

const videoText = $('.video-slider__text');
videoText.hide();  // wait for video load

$(window).on('load', function () {
    const getDefaultPlayerParams = id => ({
        id, allowDVR: true, skin: {
            theme: 1,
            customLayout: {
                controlsLeft: ["rewind/1"]
            }
        }
    });
    const getVideoID = IDString => IDString.split('-')[0];
    const videoSlider = $('.video-slider')
    videoText.show();

    if (videoSlider.length) {
        const players = [];

        $.each(videoSlider, (_, sl) => {
            const sliderId = $(sl).parent().parent().attr('id');
            const isAutoplay = $(sl).parent().parent().data('autoplay');

            setLoader(sliderId, true);

            players.push({
                sliderId,
                isAutoplay,
                players: []
            });
        });

        const elementsOfSlider = $('.video-slider__player')

        const firstElements = Object.values(elementsOfSlider).filter(el => {
            const id = el['id'];
            return id?.includes('0-mod') ?? false;
        });

        $.each(firstElements, (idx, item) => {
            const id = $(item).attr('id');

            players[idx].players.push({
                id,
                player: initPlayer(id, getVideoID(id)),
                isEnded: false,
                isCurrent: true
            });
        });
        // make sure everyone has text block which is display none by template
        $.each(videoSlider, (_, videoSlide) => {
            $('.video-slider__item', videoSlide).each((__, item) => {
                const textblock = $('.video-slider__text', item)
                if (!textblock.length) {
                    $(item).append("<div class='video-slider__text slick_arrow_container' />");
                }
            })
        });

        $.each(videoSlider, (_, videoSlide) => {
            const textBlocks = $('.video-slider__text', videoSlide)
            let maxHeightOfTextBlock = 0
            $.each(textBlocks, (_, block) => {
                if (block.clientHeight > maxHeightOfTextBlock) {
                    maxHeightOfTextBlock = block.clientHeight
                }
            })
            $.each(textBlocks, (_, block) => {
                if (maxHeightOfTextBlock < 20) {
                    block.style.display = 'none'
                } else {
                    block.style.height = `${maxHeightOfTextBlock+10}px`
                }
            })
        })

        videoSlider.on('init', function () {
            const sliderId = $(this).parent().parent().attr('id');
            const currentSliderPlayer = players.find(player => player.sliderId === sliderId)
            const currentPlayer = currentSliderPlayer.players[0].player

            setLoader(sliderId);

            const isAutoplay = Boolean($(this).parent().parent().data('autoplay') === 'on');

            currentPlayer.on('ended', onEnded.bind(null, currentSliderPlayer, sliderId, isAutoplay))
        })

        videoSlider.on('beforeChange', (event, _, currentSlide) => {
            const sliderId = $(event.currentTarget).parent().parent().attr('id');
            const currentSliderPlayer = players.find(player => player.sliderId === sliderId)
            const currentPlayer = (currentSliderPlayer.players[currentSlide]) ?? currentSliderPlayer.players[0];
            currentPlayer.isCurrent = false

            if (!currentPlayer.isEnded) {
                currentPlayer.player.stopVideo()
            }
        })

        videoSlider.on('afterChange', (event, _, currentSlide) => {
            const sliderId = $(event.currentTarget).parent().parent().attr('id');
            const currentSliderPlayer = players.find(player => player.sliderId === sliderId);

            const vid = Object.values(elementsOfSlider).find(el => {
                const id = el['id'];
                const moduleId = sliderId.split('module-')[1];
                return id?.includes(`${currentSlide}-${moduleId}`) ?? false;
            })?.id;

            const sliderPlayer = players.find(({sliderId: id}) => id === sliderId);
            const isAutoplay = Boolean(sliderPlayer.isAutoplay === 'on');

            if (vid && !players.find(({players}) => Boolean(players.find(({id}) => vid === id)))) {
                const player = initPlayer(vid, getVideoID(vid), isAutoplay);

                currentSliderPlayer.players.push({
                    id: vid,
                    player,
                    isEnded: false,
                    isCurrent: true
                })

                player.on('ended', onEnded.bind(null, currentSliderPlayer, sliderId, isAutoplay));
            } else {
                currentSliderPlayer.players[currentSlide].isCurrent = true;
            }
        })

        videoSlider.slick({
            variableWidth: false,
            slidesToShow: 1,
            infinite: true,
            dots: true,
            prevArrow: '<span class="slider-prev" aria-label="Previous" type="button">\n' +
                '                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve">\n' +
                '                                        <path d="M14.4 15.1 11.3 12l3.1-3.1L13 7.5 8.5 12l4.5 4.5 1.4-1.4zM22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10 10-4.5 10-10zM4 12c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8z"/>\n' +
                '                                        </svg>\n' +
                '                                    </span>',
            nextArrow: ' <span class="slider-next" aria-label="Next" type="button">\n' +
                '                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve">\n' +
                '                                        <path d="m9.6 8.9 3.1 3.1-3.1 3.1 1.4 1.4 4.5-4.5L11 7.5 9.6 8.9zM2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2 2 6.5 2 12zm18 0c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"/>\n' +
                '                                        </svg>\n' +
                '                                    </span>',
        })
    }

    function setLoader(id, isLoading = false) {
        const element = $(`#${id}`);
        const preloader = element.find('.video-slider-module__loader');
        const preloaderContainer = element.find('.galleryWrapper');
        const videoText = element.find('.video-slider__text');
        if (isLoading) {
            preloaderContainer.addClass('position-relative');
            preloader.addClass('position-loader');
        } else {
            preloader.removeClass('position-loader').hide();
        }

    }

    function onEnded(sliderPlayers, sliderId, isAutoplay = true) {
        const player = sliderPlayers.players.find(({isCurrent}) => isCurrent);

        player.isEnded = true;

        if (player.player.isFullScreen()) {
            const id = player.id;
            player.player.toggleFullScreen(document.getElementById(id));
        }

        if (isAutoplay) {
            $(`#${sliderId}`).find('.video-slider').slick('slickNext');
        }
    }
});
